export const ACTION_LOAD_SITE_GOOGLE_TOOL__REQUEST = 'ACTION_LOAD_SITE_GOOGLE_TOOL__REQUEST';
export const ACTION_LOAD_SITE_GOOGLE_TOOL__SUCCESS = 'ACTION_LOAD_SITE_GOOGLE_TOOL__SUCCESS';
export const ACTION_LOAD_SITE_GOOGLE_TOOL__FAIL = 'ACTION_LOAD_SITE_GOOGLE_TOOL__FAIL';

export const ACTION_UPLOAD_SITE_GOOGLE_TOOL_FILE__REQUEST = 'ACTION_UPLOAD_SITE_GOOGLE_TOOL_FILE__REQUEST';
export const ACTION_UPLOAD_SITE_GOOGLE_TOOL_FILE__SUCCESS = 'ACTION_UPLOAD_SITE_GOOGLE_TOOL_FILE__SUCCESS';
export const ACTION_UPLOAD_SITE_GOOGLE_TOOL_FILE__FAIL = 'ACTION_UPLOAD_SITE_GOOGLE_TOOL_FILE__FAIL';

export const ACTION_DELETE_SITE_GOOGLE_TOOL__REQUEST = 'ACTION_DELETE_SITE_GOOGLE_TOOL__REQUEST';
export const ACTION_DELETE_SITE_GOOGLE_TOOL__SUCCESS = 'ACTION_DELETE_SITE_GOOGLE_TOOL__SUCCESS';
export const ACTION_DELETE_SITE_GOOGLE_TOOL__FAIL = 'ACTION_DELETE_SITE_GOOGLE_TOOL__FAIL';
